
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;


class MedicalRep {
  create = async (medicalRep: any) => {
    const res = await axios.post<any>(`${API_URL}medical-rep`, medicalRep)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data;
  };

  edit = async (medicalRep: any, code: any) => {
    await axios.put<any>(`${API_URL}medical-rep/${code}`, medicalRep)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}medical-rep/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.medicalRep;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}medical-rep`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.medicalRep;
  };

  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}medical-rep-search/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.medicalRep;
  };

  repSearch = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}rep-search-receipt-based/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.repSearch;
  };
}

export default new MedicalRep();
